import React from 'react'
import { ParentDashboard } from './ParentDashboard'
import { ParentDashboardV2 } from './ParentDashboardV2'

/**
 * Parent dashboard entry point.
 *
 * ParentDashboardV2 (tile UX) is the canonical parent experience. The legacy
 * `ParentDashboard` (sidebar) is deprecated — kept behind a `?classic=1`
 * backdoor for Tom while we retire remaining bits of old UI. New parent
 * navigation / features should only be wired into V2.
 *
 * The previous `useDashboardV2` A/B split caused several "new feature only
 * appears for some users" incidents. Standardizing on V2 removes the footgun.
 */
export const ParentDashboardWrapper: React.FC = () => {
  const params = new URLSearchParams(window.location.search)
  const useClassic = params.get('classic') === '1'

  if (useClassic) {
    return <ParentDashboard />
  }

  return <ParentDashboardV2 />
}
